import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';

import s from 'components/toggle/toggle.sss';

export default class Toggle extends Component {
	render(props) {
		const { dark, small, class: parentClass, children, ...rest } = props;
		const hasChildren = !!children && (!Array.isArray(children) || children.length > 0);
		return (
			<label class={joinClasses(parentClass, dark && s.dark, small && s.small, s.wrapper)}>
				<input {...rest} type="checkbox" class={s.input} />
				{hasChildren && <div class={s.label}>{children}</div>}
			</label>
		);
	}
}